import { render, staticRenderFns } from "./DefaultVuePage.vue?vue&type=template&id=0e4a7957&scoped=true&"
import script from "./DefaultVuePage.vue?vue&type=script&lang=ts&"
export * from "./DefaultVuePage.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultVuePage.vue?vue&type=style&index=0&id=0e4a7957&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4a7957",
  null
  
)

export default component.exports